import styled from "styled-components"
import {
  TitleGroup as BaseTitleGroup,
  Text,
} from "../../../../components/elements"

interface ITitleGroupProps {
  subtitle: string
  title: React.ReactNode
}

const StyledText = styled(Text)`
  font-size: clamp(0.7rem, 0.64rem + 0.3vw, 1rem);
  text-align: center;
`

const Heading = styled.h1`
  font-size: 3rem;
  font-size: clamp(1.2rem, 0.84rem + 1.8vw, 3rem);
  margin-block: 0;
`

const TitleGroup = (props: ITitleGroupProps) => {
  const { title, subtitle } = props
  return (
    <BaseTitleGroup>
      <StyledText primary>{subtitle}</StyledText>
      <Heading>{title}</Heading>
    </BaseTitleGroup>
  )
}

export { TitleGroup }
